import { ApiNamespaces, IQueuedRequest, OneAPIOptions } from '../../common'
import { AppTranslationsApi } from './app'
import { BackofficeTranslationsApi } from './backoffice'
import { Queue } from '../../queue'

export class Translations implements ApiNamespaces {
  app: AppTranslationsApi
  backoffice: BackofficeTranslationsApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.app = new AppTranslationsApi(name, sessionId, requestsQueue, options)
    this.backoffice = new BackofficeTranslationsApi(
      name,
      sessionId,
      requestsQueue,
      options
    )
  }

  invalidateAll() {
    this.app.invalidateAll()
    this.backoffice.invalidateAll()
  }
}
